import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import xmlConverter from 'xml-js';
import Slider from 'rc-slider';

import * as experimentsActions from '../../actions/actionsExperiments';

import dataContent from '../../data/content.json';

import 'rc-slider/assets/index.css';

class FilmSlider extends Component {
  constructor (props) {
    super(props);

    this.handleSliderChange = this.handleSliderChange.bind(this);
  }

  componentDidMount() {
    this.loadProject();
  }

  componentDidUpdate(prevProps) {
    const { filmProjectObject } = this.props.experiments;
    const { projectId } = this.props.match.params;

    if (projectId !== prevProps.match.params.projectId) {
      this.loadProject();
    }

    if ((filmProjectObject && !prevProps.experiments.filmProjectObject) || (filmProjectObject.id !== prevProps.experiments.filmProjectObject.id)) {
      axios.get(filmProjectObject['final-draft-file'])
        .then((response) => {
          console.log(JSON.parse(xmlConverter.xml2json(response.data)));
        });
    }
  }

  loadProject() {
    const { projectId } = this.props.match.params;

    this.props.actions.setFilmSliderProject(_.find(dataContent['film-slider'].projects, { 'id': projectId }));
  }

  handleSliderChange(value) {
    this.props.actions.setSliderValue(value);
  }

  render() {
    const { filmProjectObject, sliderValue } = this.props.experiments;

    return (
      <React.Fragment>
        {filmProjectObject && (
          <React.Fragment>
            <div className="film-image-wrapper">
              {filmProjectObject.images && <img src={filmProjectObject.images[sliderValue]} alt="" />}
            </div>
            <Slider 
              max={filmProjectObject.images.length - 1}
              dots={true}
              onChange={this.handleSliderChange} 
            />
            <h3>All Inspiration Images</h3>
            <br/>
            <div className="all-images">
              {filmProjectObject && filmProjectObject.images.map((url, i) => <a key={i} href={url} target="_blank"><img src={url} alt="" /></a>)}
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    experiments: state.experiments
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(experimentsActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilmSlider);



// WEBPACK FOOTER //
// ./src/components/experiments/FilmSliderProject.js